/* tbs-range-filters (2026-07) - adds min/max range controls (dual-thumb slider
   + number inputs) to numeric list facets rendered by tbs-native-filters. The
   Storefront Filtering API only exposes discrete values for metafield filters,
   so Apply selects every value whose parsed number falls inside the range and
   navigates via a synthetic facet link, which tbs-ajax-filters.js intercepts
   (AJAX swap + GA4 events). Parses decimal, fractional (3/8", 1-1/16",
   1 3/16"), "N in" and "Nmm" notations, so 0.375" and 3/8" merge to one slider
   stop - no Search & Discovery grouped-values cleanup needed. Facets mixing
   inch and mm values get one slider per unit; only narrowed sliders constrain,
   untouched units contribute nothing. Also collapses the per-value chips of a
   slider facet into one summary chip and recounts the drawer badge. */
(function () {
  'use strict';
  if (window.__tbsRangeFilters) return;
  window.__tbsRangeFilters = true;

  var LABELS = ['Length', 'Width', 'Bore Size', 'Inner Diameter', 'Outer Diameter', 'Seal Width'];

  var style = document.createElement('style');
  style.textContent = '.tbs-range{padding:4px 0 8px}.tbs-range__unit{font-size:.85em;opacity:.7;margin:4px 0 0}.tbs-range__track{position:relative;height:22px;margin:4px 2px}.tbs-range__track input[type=range]{position:absolute;left:0;top:0;width:100%;height:22px;margin:0;background:none;pointer-events:none;-webkit-appearance:none;appearance:none}.tbs-range__track input[type=range]::-webkit-slider-runnable-track{height:4px;background:#e1e3e4;border-radius:2px;margin-top:9px}.tbs-range__track input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;pointer-events:auto;width:16px;height:16px;margin-top:-6px;border-radius:50%;background:#1B2A4A;border:2px solid #fff;box-shadow:0 1px 3px rgba(0,0,0,.4);cursor:pointer}.tbs-range__track input[type=range]::-moz-range-track{height:4px;background:#e1e3e4}.tbs-range__track input[type=range]::-moz-range-thumb{pointer-events:auto;width:12px;height:12px;border-radius:50%;background:#1B2A4A;border:2px solid #fff;cursor:pointer}.tbs-range__inputs{display:flex;gap:6px;align-items:center;padding:2px 0 6px}.tbs-range__inputs input{width:45%;min-width:0}';
  document.head.appendChild(style);

  function parseVal(raw) {
    var s = raw.trim();
    var m = s.match(/^(\d+(?:\.\d+)?)\s*mm$/i);
    if (m) return { n: parseFloat(m[1]), u: 'mm' };
    m = s.match(/^(\d+)[\s-](\d+)\/(\d+)\s*(?:"|in\.?)?$/i);
    if (m) return { n: parseInt(m[1], 10) + parseInt(m[2], 10) / parseInt(m[3], 10), u: 'in' };
    m = s.match(/^(\d+)\/(\d+)\s*(?:"|in\.?)?$/i);
    if (m) return { n: parseInt(m[1], 10) / parseInt(m[2], 10), u: 'in' };
    m = s.match(/^(\d+(?:\.\d+)?)\s*(?:"|in\.?)?$/i);
    if (m) return { n: parseFloat(m[1]), u: 'in' };
    return null;
  }

  function fmt(n) {
    return String(Math.round(n * 1000) / 1000);
  }

  function nearestIdx(arr, x) {
    var best = 0, d = Infinity, i, dd;
    for (i = 0; i < arr.length; i++) {
      dd = Math.abs(arr[i] - x);
      if (dd < d) { d = dd; best = i; }
    }
    return best;
  }

  function groupLabel(group) {
    var btn = group.querySelector('.collection__filter-group-name');
    return btn ? btn.textContent.split('(')[0].trim() : '';
  }

  function itemsOf(group) {
    var out = [];
    group.querySelectorAll('.collection__filter-checkbox a').forEach(function (a) {
      var span = a.querySelector('.link--primary');
      if (!span || !span.childNodes.length) return;
      var label = span.childNodes[0].textContent.trim();
      out.push({
        label: label,
        active: !!a.querySelector('input:checked'),
        parsed: parseVal(label),
        href: a.getAttribute('href') || ''
      });
    });
    return out;
  }

  function paramNameFor(items) {
    var i, qs, hit, label;
    for (i = 0; i < items.length; i++) {
      qs = items[i].href.split('?')[1];
      if (!qs) continue;
      hit = null;
      label = items[i].label;
      new URLSearchParams(qs).forEach(function (v, k) {
        if (!hit && k.indexOf('filter.') === 0 && v === label) hit = k;
      });
      if (hit) return hit;
    }
    return null;
  }

  function navigateTo(url, sec) {
    var li = document.createElement('li');
    li.className = 'collection__filter-checkbox';
    li.style.display = 'none';
    var a = document.createElement('a');
    a.href = url;
    li.appendChild(a);
    var host = sec.querySelector('.collection__filter-checkbox-list') || sec;
    host.appendChild(li);
    a.click();
    li.remove();
  }

  function buildFamily(unit, famItems, showUnit) {
    var uniq = [];
    famItems.forEach(function (it) {
      if (uniq.indexOf(it.parsed.n) < 0) uniq.push(it.parsed.n);
    });
    uniq.sort(function (a, b) { return a - b; });
    var actives = famItems.filter(function (it) { return it.active; }).map(function (it) { return it.parsed.n; });
    var lo = actives.length ? nearestIdx(uniq, Math.min.apply(null, actives)) : 0;
    var hi = actives.length ? nearestIdx(uniq, Math.max.apply(null, actives)) : uniq.length - 1;

    var wrap = document.createElement('div');
    wrap.className = 'tbs-range';
    if (showUnit) {
      var ulab = document.createElement('div');
      ulab.className = 'tbs-range__unit';
      ulab.textContent = unit === 'mm' ? 'Millimeters' : 'Inches';
      wrap.appendChild(ulab);
    }
    var track = document.createElement('div');
    track.className = 'tbs-range__track';
    var rMin = document.createElement('input');
    var rMax = document.createElement('input');
    [rMin, rMax].forEach(function (r) {
      r.type = 'range';
      r.min = 0;
      r.max = uniq.length - 1;
      r.step = 1;
      track.appendChild(r);
    });
    rMin.value = lo;
    rMax.value = hi;
    wrap.appendChild(track);

    var row = document.createElement('div');
    row.className = 'tbs-range__inputs';
    var nMin = document.createElement('input');
    var nMax = document.createElement('input');
    [nMin, nMax].forEach(function (n) { n.type = 'number'; n.step = 'any'; });
    nMin.value = fmt(uniq[lo]);
    nMax.value = fmt(uniq[hi]);
    var sep = document.createElement('span');
    sep.textContent = 'to';
    row.appendChild(nMin);
    row.appendChild(sep);
    row.appendChild(nMax);
    wrap.appendChild(row);

    function sync() {
      nMin.value = fmt(uniq[Math.min(+rMin.value, +rMax.value)]);
      nMax.value = fmt(uniq[Math.max(+rMin.value, +rMax.value)]);
    }
    rMin.addEventListener('input', function () {
      if (+rMin.value > +rMax.value) rMin.value = rMax.value;
      sync();
    });
    rMax.addEventListener('input', function () {
      if (+rMax.value < +rMin.value) rMax.value = rMin.value;
      sync();
    });
    nMin.addEventListener('change', function () {
      rMin.value = nearestIdx(uniq, parseFloat(nMin.value) || uniq[0]);
      if (+rMin.value > +rMax.value) rMax.value = rMin.value;
      sync();
    });
    nMax.addEventListener('change', function () {
      rMax.value = nearestIdx(uniq, parseFloat(nMax.value) || uniq[uniq.length - 1]);
      if (+rMax.value < +rMin.value) rMin.value = rMax.value;
      sync();
    });

    return {
      el: wrap,
      items: famItems,
      lo: function () { return uniq[Math.min(+rMin.value, +rMax.value)]; },
      hi: function () { return uniq[Math.max(+rMin.value, +rMax.value)]; },
      full: function () {
        return Math.min(+rMin.value, +rMax.value) === 0 &&
          Math.max(+rMin.value, +rMax.value) === uniq.length - 1;
      }
    };
  }

  function enhanceGroup(group, sec) {
    if (group.querySelector('.tbs-range')) return;
    if (LABELS.indexOf(groupLabel(group)) < 0) return;
    var list = group.querySelector('.collection__filter-checkbox-list');
    if (!list) return;
    var items = itemsOf(group);
    var param = paramNameFor(items);
    if (!param) return;
    var fams = {};
    items.forEach(function (it) {
      if (it.parsed) (fams[it.parsed.u] = fams[it.parsed.u] || []).push(it);
    });
    Object.keys(fams).forEach(function (u) { if (fams[u].length < 3) delete fams[u]; });
    var units = Object.keys(fams);
    if (!units.length) return;

    var box = document.createElement('div');
    var built = units.map(function (u) { return buildFamily(u, fams[u], units.length > 1); });
    built.forEach(function (f) { box.appendChild(f.el); });
    var apply = document.createElement('button');
    apply.type = 'button';
    apply.className = 'button button--small button--secondary button--full';
    apply.textContent = 'Apply range';
    box.appendChild(apply);
    list.parentNode.insertBefore(box, list);

    var covered = items.filter(function (it) { return it.parsed && fams[it.parsed.u]; }).length;
    if (covered === items.length) list.style.display = 'none';

    apply.addEventListener('click', function () {
      var u2 = new URL(location.href);
      u2.searchParams['delete'](param);
      u2.searchParams['delete']('page');
      built.filter(function (f) { return !f.full(); }).forEach(function (f) {
        f.items.forEach(function (it) {
          if (it.parsed.n >= f.lo() && it.parsed.n <= f.hi()) u2.searchParams.append(param, it.label);
        });
      });
      navigateTo(u2.pathname + u2.search, sec);
    });
  }

  function collapseChips(sec) {
    sec.querySelectorAll('.collection__filter-group').forEach(function (group) {
      var lbl = groupLabel(group);
      if (LABELS.indexOf(lbl) < 0) return;
      var items = itemsOf(group);
      var act = items.filter(function (it) { return it.active; });
      if (act.length < 3) return;
      var param = paramNameFor(items);
      if (!param) return;
      var values = act.map(function (it) { return it.label; });
      sec.querySelectorAll('.collection__active-filters').forEach(function (block) {
        var chips = [];
        block.querySelectorAll('.collection__active-filter-item').forEach(function (c) {
          if (values.indexOf(c.textContent.trim()) >= 0) chips.push(c);
        });
        if (chips.length < 3) return;
        var u2 = new URL(location.href);
        u2.searchParams['delete'](param);
        u2.searchParams['delete']('page');
        var chip = document.createElement('a');
        chip.className = 'collection__active-filter-item';
        chip.style.textDecoration = 'none';
        chip.href = u2.pathname + u2.search;
        chip.textContent = '✕ ' + lbl + ': ' + values.length + ' selected';
        chips[0].parentNode.insertBefore(chip, chips[0]);
        chips.forEach(function (c) { c.remove(); });
      });
    });
    var badge = sec.querySelector('.collection-drawer__filter-count');
    if (badge) {
      var n = sec.querySelectorAll('#mobile-collection-filters .collection__active-filter-item').length;
      badge.textContent = '(' + n + ')';
      badge.style.display = n > 0 ? 'inline' : 'none';
    }
  }

  function run() {
    var sec = document.querySelector('section[data-section-type="collection"]');
    if (!sec) return;
    sec.querySelectorAll('.collection__filter-group').forEach(function (g) { enhanceGroup(g, sec); });
    collapseChips(sec);
  }

  run();
  document.addEventListener('tbs:collection:updated', function () { run(); });
})();